<template>
  <div v-show="isCardActiveLocal">
    <div class="clickpagequizviewer">
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2">
          <h3>{{ question ? question.title : "" }}</h3>
        </div>
      </div>
      <div class="vx-row textcenter" v-if="question">
        <div class="vx-col w-full mb-2">
          <div v-html="question.questionText"></div>
        </div>
      </div>

      <div v-if="question.imageUrl" class="quizimage">
        <img :src="question.imageUrl" class="clickimageactive" style="width: 100% !important; height: 100%; border-radius:15px;">
      </div>
    </div>

    <div class="gridcolumns" style="overflow:auto">
      <div v-if="question" style="text-align: -webkit-center;text-align: -moz-center;">
          <ag-grid-vue 
            v-show="!cellTextPopupActive"
            ref="agGridTable"
            :gridOptions="gridOptions"
            class="ag-theme-material w-full my-2 ag-grid-table"
            :style="columnwidthaggrid"
            :columnDefs="question.columnValues"
            :rowData="question.rowValues"
            :defaultColDef="defaultColDef"
            colResizeDefault="shift"
            :domLayout="'autoHeight'"
            :animateRows="true"
            :singleClickEdit="true"
            @cellEditingStarted="onEditStart"
            @cellClicked="cellClicked"
            v-model="gridData"
            gridOptions.singleClickEdit = true>
          </ag-grid-vue>
          <span class="table-swipe-label centereverything w-full" style="margin-top: -4rem !important;padding-bottom: 2rem;"><small>Swipe to see more</small><feather-icon class="pl-2" icon="ArrowRightIcon" svg-classes="stroke-current h-3 w-3"></feather-icon></span>
        </div>
    </div>

    <div id="cellTextPopup" title="" v-show="cellTextPopupActive">
      <vs-textarea id="cellTextArea" v-model="cellText" ref="cellText"/>
      <div class="mt-3">
        <vs-button color="success" class="float-right mb-5" v-show="cellTextPopupActive" @click="submitText">Update Cell</vs-button>
      </div>
    </div>

    <vs-popup id="cellViewPopup" title="" :active.sync="cellViewPopupActive">
      <vs-textarea :disabled="true" id="cellViewArea" v-model="cellView" ref="cellView"/>
      <div class="mt-3">
        <vs-button color="warning" class="float-right" @click="cellViewPopupActive = false">Cancel</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
  import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
  import { AgGridVue } from 'ag-grid-vue'
  export default {
    components: {
      AgGridVue
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      isStudent: {
        type: Boolean,
        required: false
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          self.resizeCard();
          this.$emit("initValues");
          var temp = self.question.questionText;
        }
      },
      cellTextPopupActive: function(val) {
        this.resizeCard();       
        if(!val){
          this.cellText = "";
        } 
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("initValues");
          }
        }
      },
    },
    data() {
      return {
        textareaModel: "",
        gridApi: null,
        gridOptions: {},       
        currentRow: "",
        currentCol: "",
        cellView: "",
        cellTextPopupActive: false,
        cellViewPopupActive: false,
        singleClickEdit: true,
        cellText: "",
        defaultColDef: {
          sortable: false,
          editable: true,
          resizable: true,
          suppressMenu: true,
          suppressMovable: true,
        },
        columnwidthaggrid: "",
        gridData:null,
      }
    },
    methods: {
      resizeCard() {
        // if(this.gridApi)
        //   this.gridApi.sizeColumnsToFit();
      },
      onEditStart(val1){
        this.cellTextPopupActive = true;
        this.currentCol = val1.column.colId;
        var rowIn = val1.rowIndex;
        this.currentRow = this.question.rowValues[rowIn]; 
        if (this.currentRow[this.currentCol]) {
          this.cellText = this.currentRow[this.currentCol];
        } else {
          this.cellText = "";
        }
        this.gridData;
        this.gridApi.stopEditing();
        setTimeout(() => {
          document.getElementById("cellTextArea").focus();
        }, 200);
      },
      submitText(){
        this.currentRow[this.currentCol] = this.cellText;
        this.cellTextPopupActive = false;
        this.gridApi.refreshCells();
        this.$emit("tableUpdated",this.cellText);
        setTimeout(() => {
          this.gridApi.refreshClientSideRowModel();
        }, 400);
        this.cellText = "";
      },
      cellClicked(val1){
        var colIn = val1.column.colId;
        var rowIn = val1.rowIndex;
        if(colIn == "question"){
          this.cellViewPopupActive = true;
          this.cellView = val1.data.question;
        }
      }
    },
    mounted() {
      var self = this;
      self.gridApi = self.gridOptions.api;
      // this.gridApi.sizeColumnsToFit();
      var columnsLength = self.question.columnValues.length;
      self.columnwidthaggrid = (columnsLength * 200.5).toString();
      self.columnwidthaggrid = "width: " + self.columnwidthaggrid + "px !important";

      
      window.addEventListener('resize', () => {
        const windowWidth = window.outerWidth;
        const windowHeight = window.outerHeight;
        const screenWidth = screen.width;
        const screenHeight = screen.height;

        if (windowWidth === screenWidth && windowHeight === screenHeight) {
          self.resizeCard();
        }
      });
      self.$nextTick(() => {
        window.addEventListener('resize', () => {
          self.resizeCard();
        });
      });
    },
  };
</script>

<style lang="scss">
  .ag-cell{
    padding: 0px !important;
    flex: 1 1 auto;
    justify-content: center;
    text-align: center !important;
  }
  .ag-header-cell-label{
    flex: 1 1 auto;
    justify-content: center;
  }
  .ag-header-cell{
    padding: 0px !important;
    text-align: center;
  }
  .cellItems{
    display: unset !important;
    flex: unset !important;
    align-items: unset !important;
    align-self: unset !important;
    text-align: center !important;
    
  }

  #cellTextArea, #cellViewArea {
    height: 200px;
  }

  #cellTextPopup, #cellViewPopup {
    .vs-component.vs-con-textarea.vs-textarea-primary:not(.focusx){
      border-color: #828282 !important;
    }

    .focusx.vs-textarea-primary {
      border: 1px solid rgba(var(--vs-primary),1)!important;
    }

    z-index: 99999;
  }

  .ag-grid-table {
    height: -webkit-fill-available !important;
    border: 0.5px solid #e2e2e2 !important;
    &.ag-theme-material {
      .ag-header-cell {
        border-right: solid .1pt #eaeaea !important;
        &:hover {
          background-color: rgb(220, 220, 220) !important;
        }
      }
    }

    .ag-cell-focus:not(.ag-cell-range-selected) {
      border: 1px solid !important;
      border-color: #3f51b5 !important;
    }
  }
  .ag-grid-table{
    margin-bottom: 5rem !important;
  }

  .textcenter{
    text-align: center !important;
  }
  @media only screen and (max-width: 400px){
    .ag-header-cell-label{
      overflow: auto;
      .ag-header-cell-text{
        overflow: auto;
        width: 100%;
        height: 100%;
        align-items: center;
        white-space: initial !important;
      }
    }
  }

  .gridcolumns{
    overflow: scroll;
    width: 100% !important;
  }

  .ag-cell {
    cursor: pointer;
    border-right: solid .1pt #eaeaea !important;
    border-left: solid .1pt #eaeaea !important;
    &:hover {
      background-color: rgb(220, 220, 220) !important;
    }
  }

  .quizimage{
    width: 40%;
    max-height: 60%;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    padding: 20px 0px;
  }

  @media screen and (max-width: 500px) {
    .quizimage{
      width: 80%;
      max-height: 90%;
    }
  }

</style>
